"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 16 2018
 */

var AppModule_1 = require("../core/modules/AppModule");

var CurrencyConverter_1 = require("./conversions/CurrencyConverter");

var CurrencyConverterImpl_1 = require("./conversions/CurrencyConverterImpl");

var CurrencyRateConverter_1 = require("./conversions/CurrencyRateConverter");

var CurrencyRateConverterImpl_1 = require("./conversions/CurrencyRateConverterImpl");

var typescript_ioc_1 = require("@logio/typescript-ioc");
/**
 * Configures currency app module.
 */


var CurrencyAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(CurrencyAppModule, _AppModule_1$AppModul);

  function CurrencyAppModule() {
    var _this;

    _classCallCheck(this, CurrencyAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CurrencyAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'currencyAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CurrencyAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(CurrencyConverter_1.CurrencyConverter).to(CurrencyConverterImpl_1.CurrencyConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CurrencyRateConverter_1.CurrencyRateConverter).to(CurrencyRateConverterImpl_1.CurrencyRateConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return CurrencyAppModule;
}(AppModule_1.AppModule);

exports.CurrencyAppModule = CurrencyAppModule;